import api from ".";

function getRoles(): Promise<string[]> {
    return api.get("roles").then((r) => r.data);
}

export default {
    getRoles
};
